/** Ficheiro de Configuração de Acessos Remotos */

if (process.env.REACT_APP_MODE === 'production') console.log = function () { };

const webSiteTitle = 'AgroEfficiency Energy Monitoring'

const webSiteAdress = ''

const companycode = '0000000';

//const contactFrom = 'web.dev@assec.pt';

const contactFrom = process.env.REACT_APP_API_EMAIL_CONTACT



// ########################### CONFIG ##################################

const FOOTER_EMAIL_COLOR = '#333333'

console.log('HOSTS---------------------------------------------------------')

console.log('HOSTS APPLICATION_URL:', process.env.REACT_APP_PRINCIPAL_URL)

console.log('HOSTS APPLICATION_SITE_URI:', process.env.REACT_APP_PRINCIPAL_URL)
const WEB_SITE_URI = process.env.REACT_APP_SITE_URI

console.log('HOSTS APPLICATION_BACKOFFICE_URI:', process.env.REACT_APP_GEST_URI)
const WEB_BACKOFFICE_URI = process.env.REACT_APP_GEST_URI

console.log('NODE_ENV SIMCore_API:', process.env.REACT_APP_API_URL)
const SIMCore_API = process.env.REACT_APP_API_URL;

console.log('NODE_ENV APP_REPO_FOLDER:', process.env.REACT_APP_REPO_FOLDER)
const APP_REPO_FOLDER = process.env.REACT_APP_REPO_FOLDER

console.log('NODE_ENV REPO URL:', process.env.REACT_APP_REPO_URL)
const REPO = process.env.REACT_APP_REPO_URL

console.log('NODE_ENV SIMCore_API_MAIL:', process.env.REACT_APP_API_EMAIL_URL)
const SIMCore_API_MAIL = process.env.REACT_APP_API_EMAIL_URL


console.log('NODE_ENV EMAIL_WEB_SITE_URL:', process.env.REACT_APP_SITE_URL)
console.log('NODE_ENV EMAIL_WEB_SITE_URL_REAL :', process.env.REACT_APP_SITE_URL_REAL)
const EMAIL_WEB_SITE_URL = process.env.REACT_APP_SITE_URL_REAL

console.log('NODE_ENV EMAIL_WEB_BACKOFFICE_URL:', process.env.REACT_APP_GEST_URL)
console.log('NODE_ENV EMAIL_WEB_BACKOFFICE_URL_REAL:', process.env.REACT_APP_BACKOFFICE_URL_REAL)
const EMAIL_WEB_BACKOFFICE_URL = process.env.REACT_APP_BACKOFFICE_URL_REAL


// #####################################################################




//Begin exporting all variables
module.exports = {
    SIMCore_API,
    SIMCore_API_MAIL,

    FOOTER_EMAIL_COLOR,
    REPO,
    APP_REPO_FOLDER,
    WEB_SITE_URI,
    WEB_BACKOFFICE_URI,
    EMAIL_WEB_SITE_URL,
    EMAIL_WEB_BACKOFFICE_URL,

    //COMENTAR E VERIFICAR SE FALTA SUBSTITUIR EM ALGUM LADO
    //webSiteURL,
    //emailWebSiteURL,
    //emailBackofficeURL,
    //backofficeURL,

    webSiteTitle,
    webSiteAdress,
    companycode,
    contactFrom
};





